import { defineMessages } from 'react-intl';

export default defineMessages({
  gettingStartedTitle: {
    id: 'gettingStarted.title',
    defaultMessage: 'Get started',
  },
});
